<template>
  <div class="editContainer" @dragenter.stop.prevent="onDragenter" @dragleave.stop.prevent @dragover.stop.prevent @drop.stop.prevent>
    <div id="mindMapContainer" ref="mindMapContainer" class="mindMapContainer" />
    <NavigatorToolbar :mind-map="mindMap" />
    <div class="ext-tools">
      <a-button type="primary" :loading="saveLoading" @click="save"> 保存 </a-button>
    </div>
    <Contextmenu v-if="mindMap" :mind-map="mindMap" />
    <!-- 小地图 -->
    <Navigator v-if="mindMap" :mind-map="mindMap" />
    <NodeImgPreview v-if="mindMap" :mind-map="mindMap" />
  </div>
</template>

<script>
import MindMap from 'simple-mind-map';
import MiniMap from 'simple-mind-map/src/plugins/MiniMap.js';
import RainbowLines from 'simple-mind-map/src/plugins/RainbowLines.js'; // 彩虹线
import Export from 'simple-mind-map/src/plugins/Export.js';
import Select from 'simple-mind-map/src/plugins/Select.js';
import NavigatorToolbar from './NavigatorToolbar';
import Navigator from './Navigator.vue';
import Contextmenu from './Contextmenu';
import Vue from 'vue';
import Themes from 'simple-mind-map-plugin-themes';
import icon from '../config/icon_new';
import NodeImgPreview from './NodeImgPreview.vue';

// 注册插件
MindMap.usePlugin(MiniMap).usePlugin(RainbowLines).usePlugin(Export).usePlugin(Select);
// .usePlugin(Cooperate) // 协同插件

// 注册主题
Themes.init(MindMap);

export default {
  components: {
    NavigatorToolbar,
    Contextmenu,
    Navigator,
    NodeImgPreview
  },
  props: {
    orgData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      enableShowLoading: true,
      mindMap: null,
      startData: {},
      expandCaseNameList: [],
      mindMapData: {
        config: {},
        layout: 'logicalStructure',
        theme: {
          template: 'classic11',
          config: {}
        },
        root: {
          data: {
            text: '根节点'
          }
        }
      },
      saveLoading: false,
      prevImg: '',
      storeConfigTimer: null,
      showDragMask: false
    };
  },
  watch: {
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.handleResize();
      }, 200);
    }
  },
  mounted() {
    // this.getData();
    this.init();
    this.$bus.$on('execCommand', this.execCommand);
    this.$bus.$on('setData', this.setData);
    this.$bus.$on('startTextEdit', this.handleStartTextEdit);
    this.$bus.$on('endTextEdit', this.handleEndTextEdit);
    this.$bus.$on('createAssociativeLine', this.handleCreateLineFromActiveNode);
    this.$bus.$on('startPainter', this.handleStartPainter);
    this.$bus.$on('node_tree_render_end', this.handleHideLoading);
    this.$bus.$on('showLoading', this.handleShowLoading);
    window.addEventListener('resize', this.handleResize);
    // setTimeout(() => {
    //   const _data = this.mindMap.getData(false);
    //   this.startData = JSON.parse(JSON.stringify(_data));
    // }, 500);
  },
  beforeDestroy() {
    this.$bus.$off('execCommand', this.execCommand);
    this.$bus.$off('setData', this.setData);
    this.$bus.$off('startTextEdit', this.handleStartTextEdit);
    this.$bus.$off('endTextEdit', this.handleEndTextEdit);
    this.$bus.$off('createAssociativeLine', this.handleCreateLineFromActiveNode);
    this.$bus.$off('startPainter', this.handleStartPainter);
    this.$bus.$off('node_tree_render_end', this.handleHideLoading);
    this.$bus.$off('showLoading', this.handleShowLoading);
    window.removeEventListener('resize', this.handleResize);

    this.mindMap.destroy();
  },
  methods: {
    // 手动保存
    save() {
      this.mindMap.renderer.textEdit.hideEditTextBox();
      setTimeout(() => {
        const data = this.mindMap.getData(false);
        this.$emit('save', data, this.startData, loading => {
          this.saveLoading = loading;
        });
      }, 100);
    },
    addCaseStepNode() {
      const childList = [
        {
          data: {
            text: '步骤'
          },
          children: [
            {
              data: {
                text: '结果'
              }
            }
          ]
        }
      ];
      this.mindMap.execCommand('INSERT_MULTI_CHILD_NODE', [], childList);
    },
    addCaseNode() {
      const childList = [
        {
          data: {
            text: '用例名称',
            icon: ['priority_2'],
            tag: [
              {
                text: '用例',
                style: {
                  fill: '#66DC79'
                }
              }
            ]
          },
          children: [
            {
              data: {
                text: '前置条件',
                tag: [
                  {
                    text: '前置条件',
                    style: {
                      fill: '#64C4BA'
                    }
                  }
                ]
              }
            },
            {
              data: {
                text: '步骤一'
              },
              children: [
                {
                  data: {
                    text: '结果一'
                  }
                }
              ]
            },
            {
              data: {
                text: '步骤二'
              },
              children: [
                {
                  data: {
                    text: '结果二'
                  }
                }
              ]
            },
            {
              data: {
                text: '步骤三'
              },
              children: [
                {
                  data: {
                    text: '结果三'
                  }
                }
              ]
            }
          ]
        }
      ];
      this.mindMap.execCommand('INSERT_MULTI_CHILD_NODE', [], childList);
    },

    buildCaseStep(caseMindNode, treeData) {
      if (!caseMindNode.children) caseMindNode.children = [];
      // 前置条件
      const preConditionNode = {
        data: {
          text: treeData.precondition || '无',
          nodeData: {},
          tag: [
            {
              text: '前置条件',
              style: {
                fill: '#64C4BA'
              }
            }
          ]
        },
        children: []
      };
      caseMindNode.children.push(preConditionNode);
      if (treeData.steps && treeData.steps.length > 0) {
        treeData.steps.forEach(step => {
          const resultNode = {
            data: {
              text: step ? step.result || '无' : '无',
              expand: false,
              nodeData: step
              // tag: [{
              //   text: '预期结果',
              //   style: {
              //     fill: '#F4B6F7'
              //   }
              // }]
            }
          };

          if (step.images && step.images.length > 0) {
            resultNode.children = [];
            step.images.forEach(image => {
              resultNode.children.push({
                data: {
                  text: '',
                  nodeData: image,
                  image: image.url || 'https://img.yzcdn.cn/vant/ipad.png',
                  imageSize: {
                    width: 100,
                    height: 100,
                    custom: false
                  }
                }
              });
            });
          }
          const stepNode = {
            data: {
              text: step ? step.step || '无' : '无',
              nodeData: step
              // tag: [{
              //   text: '步骤',
              //   style: {
              //     fill: '#98C9F6'
              //   }
              // }]
            },
            children: [resultNode]
          };

          caseMindNode.children.push(stepNode);
        });
      }
      if (treeData.description) {
        caseMindNode.children.push({
          data: {
            text: treeData.description,
            tag: [
              {
                text: '备注信息',
                style: {
                  fill: '#C3FDE4'
                }
              }
            ]
          }
        });
      }
    },
    buildNodeData(treeData, mindRootData) {
      if (treeData.key && (treeData.key + '').indexOf('TC') > -1) {
        const nodeData = {
          text: treeData.name,
          nodeData: treeData,
          icon: ['priority_' + treeData.priority],
          expand: this.expandCaseNameList && treeData.name && this.expandCaseNameList.indexOf(treeData.name) > -1,
          tag: [
            {
              text: '用例',
              style: {
                fill: '#66DC79'
              }
            }
          ]
        };
        const tags = treeData.tags || [];
        if (tags && tags.length > 0) {
          tags.forEach(tag => {
            nodeData.tag.push({
              text: tag.name,
              style: {
                fill: tag.color
              }
            });
          });
        }
        this.buildCaseStep(mindRootData, treeData);
        mindRootData.data = nodeData;
      } else {
        const nodeData = {
          text: treeData.name,
          nodeData: treeData,
          tag: [
            {
              text: '模块',
              style: {
                fill: '#F3B066'
              }
            }
          ]
        };
        mindRootData.data = nodeData;
      }
    },
    buildMindData(treeData, mindRootData) {
      // 模块
      const { children } = treeData;
      this.buildNodeData(treeData, mindRootData);
      if (children && children.length) {
        mindRootData.children = [];
        children.forEach(item => {
          const node = {
            data: {
              text: item.name
            }
          };
          this.buildMindData(item, node);
          mindRootData.children.push(node);
        });
      }
    },

    // 修改数据,为了提升性能
    changeData(orgData) {
      const mindRootData = {
        data: {
          text: '根节点'
        }
      };
      this.buildMindData(orgData, mindRootData);
      // this.mindMapData.root = mindRootData;
      this.mindMap.setData(mindRootData);
      setTimeout(() => {
        const _data = this.mindMap.getData(false);
        this.startData = JSON.parse(JSON.stringify(_data));
      }, 500);
    },

    // 获取思维导图数据，实际应该调接口获取
    getData() {
      // const storeData = getData();
      // console.log(JSON.parse(JSON.stringify(storeData.root)));
      // console.log(JSON.parse(JSON.stringify(storeData)));
      const treeData = this.orgData;
      const mindRootData = {
        data: {
          text: '根节点'
        }
      };
      this.buildMindData(treeData, mindRootData);

      this.mindMapData.root = mindRootData;
      // {
      //   data: {
      //     text: '根节点'
      //   },
      //   children: [
      //     {
      //       data: {
      //         text: '二级节点'
      //       }
      //     },
      //     {
      //       data: {
      //         text: '二级节点1'
      //       }
      //     }
      //   ]
      // };
    },

    // 初始化
    init() {
      const { root, layout, theme, view, config } = this.mindMapData;
      this.mindMap = new MindMap({
        el: this.$refs.mindMapContainer,
        customInnerElsAppendTo: this.$refs.mindMapContainer,
        data: root,
        fit: false,
        layout: layout,
        theme: theme.template,
        themeConfig: theme.config,
        viewData: view,
        nodeTextEditZIndex: 1000,
        nodeNoteTooltipZIndex: 1000,
        rainbowLinesConfig: {
          open: false // 开启彩虹线
        },
        customNoteContentShow: {
          show: (content, left, top, node) => {
            this.$bus.$emit('showNoteContent', content, left, top, node);
          },
          hide: () => {
            // this.$bus.$emit('hideNoteContent')
          }
        },
        openRealtimeRenderOnNodeTextEdit: true,
        enableAutoEnterTextEditWhenKeydown: true,
        ...(config || {}),
        iconList: [...icon],
        useLeftKeySelectionRightKeyDrag: false,
        // customHandleClipboardText: handleClipboardText,
        // defaultNodeImage: require('../assets/img/loadfail.svg'),
        initRootNodePosition: ['5%', 'center'],
        handleIsSplitByWrapOnPasteCreateNewNode: () => {
          return this.$confirm('是否按换行自动分割节点？', '提示', {
            confirmButtonText: '是',
            cancelButtonText: 'fou',
            type: 'warning'
          });
        },
        errorHandler: (code, err) => {
          console.error(err);
          switch (code) {
            case 'export_error':
              this.$message.error('导出失败');
              break;
            default:
              break;
          }
        },
        addContentToFooter: () => {
          // const text = this.extraTextOnExport.trim();
          const text = '';
          if (!text) return null;
          const el = document.createElement('div');
          el.className = 'footer';
          el.innerHTML = text;
          const cssText = `
            .footer {
              width: 100%;
              height: 30px;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 12px;
              color: #979797;
            }
          `;
          return {
            el,
            cssText,
            height: 30
          };
        },
        expandBtnNumHandler: num => {
          return num >= 100 ? '…' : num;
        },
        beforeDeleteNodeImg: node => {
          return new Promise(resolve => {
            this.$confirm('是否确认删除该节点图片？', '提示', {
              confirmButtonText: '是',
              cancelButtonText: '否',
              type: 'warning'
            })
              .then(() => {
                resolve(false);
              })
              .catch(() => {
                resolve(true);
              });
          });
        }
      });
      if (this.openNodeRichText) this.addRichTextPlugin();
      if (this.isShowScrollbar) this.addScrollbarPlugin();

      this.mindMap.keyCommand.addShortcut('Control+s', () => {
        this.save();
      });
      // 转发事件
      ['node_active', 'data_change', 'view_data_change', 'back_forward', 'node_contextmenu', 'node_click', 'draw_click', 'expand_btn_click', 'svg_mousedown', 'mouseup', 'mode_change', 'node_tree_render_end', 'rich_text_selection_change', 'transforming-dom-to-images', 'generalization_node_contextmenu', 'painter_start', 'painter_end', 'scrollbar_change', 'scale', 'translate', 'node_attachmentClick', 'node_attachmentContextmenu', 'demonstrate_jump', 'exit_demonstrate', 'node_note_dblclick'].forEach(event => {
        this.mindMap.on(event, (...args) => {
          this.$bus.$emit(event, ...args);
        });
      });
      // this.bindSaveEvent();
      this.bindExpandEvent();
      // 如果应用被接管，那么抛出事件传递思维导图实例
      if (window.takeOverApp) {
        this.$bus.$emit('app_inited', this.mindMap);
      }
      // api/index.js文件使用
      // 当正在编辑本地文件时通过该方法获取最新数据
      Vue.prototype.getCurrentData = () => {
        const fullData = this.mindMap.getData(true);
        return { ...fullData, config: this.mindMapData.config };
      };
      // 销毁
      // setTimeout(() => {
      //   console.log('销毁')
      //   this.mindMap.destroy()
      // }, 10000)
      // 测试
      // setTimeout(() => {
      //   console.log(this.mindMap.renderer.root.getRect())
      //   console.log(this.mindMap.renderer.root.getRectInSvg())
      // }, 5000);
      // setTimeout(() => {
      //   this.mindMap.renderer.renderTree.data.fillColor = 'red'
      //   this.mindMap.render()
      //   this.mindMap.reRender()
      //   this.mindMap.render()
      // }, 5000)
    },
    bindExpandEvent() {
      this.mindMap.on('expand_btn_click', (...args) => {
        if (!args || args.length === 0) return;
        const mindMapNode = args[0];
        if (!mindMapNode) return;
        const { nodeData } = mindMapNode;
        if (!nodeData) return;
        const { data } = nodeData;
        if (!data || !data.tag || data.tag.length === 0) return;
        const tag = data.tag.find(item => item.text === '用例');
        if (!tag) return;
        if (data.expand) {
          this.expandCaseNameList.push(data.text);
        } else {
          this.expandCaseNameList = this.expandCaseNameList.filter(item => item !== data.text);
        }
      });
    },
    // 存储数据当数据有变时
    bindSaveEvent() {
      this.$bus.$on('data_change', data => {
        // storeData(data);
      });
      this.$bus.$on('view_data_change', data => {
        clearTimeout(this.storeConfigTimer);
        this.storeConfigTimer = setTimeout(() => {
          // storeConfig({
          //   view: data
          // });
        }, 300);
      });
    },
    // 执行命令
    execCommand(...args) {
      if (args && args[0] === 'ADD_CASE_NODE') {
        this.addCaseNode();
      } else if (args && args[0] === 'ADD_CASE_STEP') {
        this.addCaseStepNode();
      }
      this.mindMap.execCommand(...args);
    },
    handleStartTextEdit() {
      this.mindMap.renderer.startTextEdit();
    },

    handleEndTextEdit() {
      this.mindMap.renderer.endTextEdit();
    },
    handleCreateLineFromActiveNode() {
      this.mindMap.associativeLine.createLineFromActiveNode();
    },
    handleStartPainter() {
      this.mindMap.painter.startPainter();
    },
    // 渲染结束后关闭loading
    handleHideLoading() {
      if (this.enableShowLoading) {
        this.enableShowLoading = false;
      }
    },
    // 显示loading
    handleShowLoading() {
      this.enableShowLoading = true;
    },
    handleResize() {
      this.mindMap.resize();
    }
  }
};
</script>

<style lang="less" scoped>
.editContainer {
  width: 100%;
  height: 100%;
  .mindMapContainer {
    width: 100%;
    height: 100%;
  }
  .ext-tools {
    position: absolute;
    right: 20px;
    top: 10px;
  }
}
</style>
